function t(r) {
  return Array.isArray(r) ? `[${r.map((n) => typeof n == "string" ? `"${n.toString().trim()}"` : typeof n == "object" ? JSON.stringify(n) : n === void 0 ? "undefined" : n === null ? "null" : n).join(", ")}]` : r === null ? "null" : typeof r == "object" ? "value" in r ? r.value : "externalValue" in r ? r.externalValue : JSON.stringify(r) : r === void 0 ? "undefined" : typeof r == "string" ? r.trim() : r.toString().trim();
}
export {
  t as formatExample
};
